import { useEffect, useMemo } from 'react';

export const useSEO = ({ language, activeTab, calculatorData = {} }) => {
  const baseUrl = 'https://petdays.homy.hk';
  
  const seoContent = useMemo(() => {
    const isZh = language === 'zh';
    const { anniversaryType, petType, petName, calculatedDays } = calculatorData;
    
    // 2026 深度語義化標題
    let title = isZh ? '寵物紀念日計算器 2026 - 記錄毛孩成長點滴' : 'Pet Milestone Calculator 2026 - Track Your Pet Journey';
    let description = isZh 
      ? '2026 專業寵物日期工具。計算領養日、生日與里程碑，為您的狗狗、貓咪或其他寵物建立專屬回憶。' 
      : 'Professional 2026 pet date tool. Calculate adoption days, birthdays, and milestones for your dogs, cats, and more.';
    
    // 針對特定寵物類型的標題優化
    if (petType && activeTab === 'pet') {
      const petMap = { dog: isZh ? '狗狗' : 'Dog', cat: isZh ? '貓咪' : 'Cat' };
      const petLabel = petMap[petType] || '';
      if (petLabel) {
        title = isZh ? `${petLabel}紀念日計算器 - 專屬${petLabel}主人的工具` : `${petLabel} Anniversary Calculator - Essential for ${petLabel} Owners`;
      }
    }

    if (activeTab === 'pet' && calculatedDays > 0) {
      const pName = petName || (isZh ? '毛孩' : 'my pet');
      title = isZh 
        ? `與${pName}相處了 ${calculatedDays} 天 | 寵物里程碑紀錄` 
        : `${calculatedDays} Days with ${pName} | Pet Milestone Tracker`;
    }

    const structuredData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "SoftwareApplication",
          "name": title,
          "description": description,
          "applicationCategory": "LifestyleApplication",
          "operatingSystem": "Web",
          "dateModified": "2026-03-04",
          "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": baseUrl },
            { "@type": "ListItem", "position": 2, "name": petType || "General", "item": `${baseUrl}/#/?petType=${petType}` }
          ]
        }
      ]
    };

    return { title, description, structuredData };
  }, [language, activeTab, calculatorData]);

  return seoContent;
};